const ems = [
  0,
  '0.25em',
  '0.5em',
  '0.75em',
  '1em',
  '1.5em',
  '2em',
  '3em',
  '4em',
];

export default ems;
